<template>
  <modal id="form-registro-td" :titulo="titulo" :loading="!form">
    <form @submit.prevent="" v-if="form" autocomplete="off">
      <card>
        <card-content class="row gutters-xs">
          <v-input :error="validation.tipoBem" v-model="form.tipoBem" :options="options.tipos" type="v-select" class="col-4" label="Tipo" />

          <div class="w-100" />

          <v-input class="col-6" v-model="form.nome" :error="validation.nome" type="text" label="Nome" />
          <v-input class="col-3" label="Data de Referência" v-model="form.dataReferencia" type="date" />
          <v-input class="col-3" label="Valor" v-model="form.valor" type="currency" :input-props="{precision : 2}" />

          <div class="w-100" />

          <v-input class="col-6" v-model="form.fabricante" type="text" label="Fabricante" />
          <v-input class="col-6" v-model="form.identificacao" type="text" label="Identificação" />

          <div class="w-100" />

          <v-input class="col-6" v-model="form.localizacao" type="text" label="Localização" />
          <v-input class="col-6" v-model="form.notaFiscal" type="text" label="Nota fiscal" />

          <div class="w-100" />

          <v-input class="col-4" label="Valor Fiscal" v-model="form.valorFiscal" type="currency" :input-props="{precision : 2}" />
          <v-input class="col-4" v-model="form.formaPagamento" type="select" label="Forma de Pagamento" :options="options.formasPagamento" />
          <v-input class="col-4" v-model="form.prazoPagamento" type="select" label="Prazo de Pagamento" :options="options.prazosPagamento" />

          <v-input class="col-12" v-model="form.detalhes" type="text" label="Detalhes" />
        </card-content>
      </card>
    </form>

    <template #footer>
      <button type="button" @click.prevent="close()" class="btn btn-outline-secondary mr-auto">Cancelar</button>
      <v-button :run="salvar" class="btn-outline-primary">Salvar</v-button>
    </template>
  </modal>
</template>

<script>

  import FrontBusiness from "@/business/FrontBusiness";
  import RegistroTDBusiness from '@/business/indicadores/RegistroTDBusiness.js';
  import utils from "@/commons/Utils";
  import Card from "@/components/Layout/components/Card.vue";
  import CardContent from "@/components/Layout/components/CardContent.vue";
  import Modal from "@/components/Modal";
  import TipoBemMovelBusiness from "@/business/crud/TipoBemBusiness";
  import BemMovelBusiness from "@/business/crud/BemMovelBusiness";

  export default {
    name: "FormBemMovel",
    components: {
      Card,
      CardContent,
      Modal
    },

    modal: {
      escapable: false
    },

    props: {
      id: String,
      livro: String,
      atribuicao: String,
      clone: {type: Object, default: () => ({})}
    },

    async created() {
      if(this.atribuicao) {
        await TipoBemMovelBusiness.getSimpleListByAtribuicao(this.atribuicao).then(l => this.options.tipos = Object.freeze(l));
      } else {
        await TipoBemMovelBusiness.getSimpleList().then(l => this.options.tipos = Object.freeze(l));
      }
    },

    async mounted() {
      let dto = {};

      if (this.id) {
        dto = await BemMovelBusiness.getById(this.id);
        this.titulo = `Editar Bem Móvel`;
      } else {
        this.titulo = 'Adicionar Bem Móvel';
        dto = {...this.clone};
      }

      let form = {
        ...dto
      };

      form.abertura = dto.abertura ? this.$moment(dto.abertura).format('YYYY-MM-DDTHH:mm:ss') : null;
      form.encerramento = dto.encerramento ? this.$moment(dto.encerramento).format('YYYY-MM-DDTHH:mm:ss') : null;

      this.$set(this, 'form', form);
    },

    data() {
      return {
        form: null,
        validation: {},
        titulo: '',
        decimais: 2,
        options: {
          tipos: [],
          statusEdicao: RegistroTDBusiness.getStatusImovel(false),
          livros: [
            {id: 'MATRICULA', nome: 'Matrícula'},
            {id: 'PRE_MATRICULA', nome: 'Pré-Matrícula'}
          ],
          formasPagamento: [
            {id: 'CHEQUE', nome: 'Cheque'},
            {id: 'DINHEIRO', nome: 'Dinheiro'},
            {id: 'NOTA_PROMISSORIA', nome: 'Nota Promissória'},
            {id: 'PERMUTA', nome: 'Permuta'},
            {id: 'TRANSFERENCIA', nome: 'Transferência'},
            {id: 'OUTRAS', nome: 'Outras'},
          ],
          prazosPagamento: [
            {id: 'A_VISTA', nome: 'À Vista'},
            {id: 'A_PRAZO', nome: 'A Prazo'},
            {id: 'ANTECIPADO', nome: 'Antecipado'},
            {id: 'ADITAMENTO', nome: 'Aditamento'},
          ]
        }
      }
    },

    methods: {
      close() {
        FrontBusiness.closeModal();
      },

      showError(e) {
        FrontBusiness.fullErrorHandler(this, e, '#form-registro-titulo');
      },

      nomearLivro: FrontBusiness.nomearFicha,

      async salvar() {
        this.form.livro = this.form.livro || 'BEM_MOVEL';
        let dto = utils.clone(this.form);
        let validated = true;
        let id = dto.tipoBem?.id || dto.tipoBem
        dto.tipoBem = id ? {id} : null;

        let obrigatorios = ['nome', 'tipoBem'];

        obrigatorios.forEach(e => {
          if (!dto[e]) {
            this.$set(this.validation, e, 'Campo obrigatório');
            validated = false;
          }
        });

        if(validated) {
          let retorno = await BemMovelBusiness.save(dto, this.id).catch(this.showError);
          if (retorno) {
            FrontBusiness.closeModal(retorno);
          }
        }
      },
    }
  }
</script>

<style lang=scss>
  #form-registro-td {
    .card {
      hr {
        margin-top: .25rem;
      }

      .busca-cep {
        margin-top: 21px;
      }

      .card-body {
        padding-bottom: 0;
      }
    }
  }
</style>
